import { useState } from 'react';
import { useReportingContext } from '../../reporting';
import { ReportingCurrencyDialog } from './ReportingCurrencyDialog';

const COMPACT_DATE_INPUT_CLASS =
  'h-8 w-[6.5rem] shrink-0 rounded border border-gray-300 bg-white px-1.5 text-xs text-gray-700 shadow-sm focus:border-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500/30';

export function GlobalReportSettingsBar() {
  const [isCurrencyDialogOpen, setIsCurrencyDialogOpen] = useState(false);
  const {
    startDate,
    endDate,
    reportingCurrency,
    hasReportingCurrency,
    setStartDate,
    setEndDate,
    setReportingCurrency,
  } = useReportingContext();

  return (
    <div className="shrink-0 border-b border-gray-200 bg-gray-50 px-3 py-1.5 sm:px-6">
      <div className="flex items-center gap-2 overflow-x-auto text-xs text-gray-600">
        <span className="hidden shrink-0 font-medium uppercase tracking-wide text-gray-500 md:inline">
          Reporting
        </span>
        <label className="flex shrink-0 items-center gap-1.5 whitespace-nowrap">
          <span className="font-medium text-gray-500">Start</span>
          <input
            type="date"
            className={COMPACT_DATE_INPUT_CLASS}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label className="flex shrink-0 items-center gap-1.5 whitespace-nowrap">
          <span className="font-medium text-gray-500">End</span>
          <input
            type="date"
            className={COMPACT_DATE_INPUT_CLASS}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
        <button
          type="button"
          className="h-8 w-36 shrink-0 rounded border border-gray-300 bg-white px-2 text-left text-xs text-gray-700 shadow-sm hover:border-gray-400 focus:border-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500/30"
          aria-haspopup="dialog"
          onClick={() => setIsCurrencyDialogOpen(true)}
          title="Choose reporting currency"
        >
          <span className="block truncate">{reportingCurrency?.trim() || 'Reporting currency'}</span>
        </button>
        {!hasReportingCurrency ? (
          <p role="status" className="shrink-0 text-xs text-amber-700" title="Some reports need a reporting currency">
            Currency required
          </p>
        ) : null}
      </div>
      {isCurrencyDialogOpen ? (
        <ReportingCurrencyDialog
          value={reportingCurrency}
          onChange={(currencyCode) => setReportingCurrency(currencyCode)}
          onClose={() => setIsCurrencyDialogOpen(false)}
        />
      ) : null}
    </div>
  );
}
